import { createAction, props } from '@ngrx/store';

export const setState = createAction(
    '[Global] Set State',
    props<{ state: string }>(),
);

export const resetState = createAction('[Global] Reset State');
